import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Checkbox Config"})
export default class CheckBoxConfig {

	@Input({type: InputType.COLOR, title: "Checkbox Color"})
	public color: string;

	@Input({type: InputType.CHECKBOX, title: "Inline"})
	public inline: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Box Style"})
	public boxStyle: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Disabled"})
	public disabled: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Large"})
	public large: boolean = false;

}



// WEBPACK FOOTER //
// ./src/common/views/checkbox/CheckboxConfig.ts